/* eslint-disable no-unused-vars */

import React, { useEffect, useState} from 'react';
import { Typography, List, ListItemButton, Box, LinearProgress, Card, CardContent, CardActions, CardMedia, CardHeader, Button, Alert, Avatar, Tooltip, CircularProgress } from '@mui/material';
//import Center from './Center';
//import useForm from '../hooks/useForm';
//import { variables } from './Variables.js';
import { green, red, grey } from '@mui/material/colors';
import { BASE_URL, createAPIEndpoint, ENDPOINTS } from '../api/index';
//import useStateContext from '../hooks/useStateContext';
import { useNavigate } from "react-router-dom";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';



export default function Home() {
    //static displayName = Home.name;
    //const [context, setContext] = useStateContext();
    const [showAlert, setShowAlert] = useState(true);
    const navigate = useNavigate()
    const [qns, setQns] = useState([]);
    const [qnIndex, setQnIndex] = useState(0);

    useEffect(() => {
        //if (location.state === null) { navigate("/") };
        createAPIEndpoint(ENDPOINTS.introduction)
            .fetch()
            .then(res => {
                setQns(res.data);
                setShowAlert(false);
                //console.log(res.data);
                // startTimer();
            })
            .catch(err => { console.log(err); })

        // return () => { clearInterval(timer) }
    }, [])

    function srcset(image, size, rows = 1, cols = 1) {
        return {
            src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
            srcSet: `${image}?w=${size * cols}&h=${size * rows
                }&fit=crop&auto=format&dpr=2 2x`,
        };
    }

    const getPrevious = () => {
        setQnIndex(qnIndex - 1);
    }

    const getNext = () => {
        setQnIndex(qnIndex + 1);
    }

    const submitQuiz = () => {
        //setTimeTaken(timeTaken);
        navigate("/login")
    }

    const getTrip = () => {
        //setTimeTaken(timeTaken);
        navigate("/trip")
    }

    const itemData = [
        {
            img: BASE_URL + 'Images/mvppict.JPG',
            title: 'Care',
            rows: 2,
            cols: 2,
        },
        {
            img: BASE_URL + 'Images/mvpHome.png',
            title: 'Home Making',
            rows: 2,
            cols: 1,
        },
        {
            img: BASE_URL + 'Images/mvpFood.png',
            title: 'Food',
            rows: 1,
            cols: 3,
        }
    ];


    //render () {
    return (
        qns.length !== 0
            ? <Card sx={{
                maxWidth: 640, mx: 'auto', mt: 1, mb: 1,
                '& .MuiCardHeader-action': { m: 0, alignSelf: 'center' }
            }}>
                <CardHeader
                    avatar={
                        <Avatar sx={{ bgcolor: red[500], fontWeight: 500 }} aria-label="recipe">
                            MVP
                        </Avatar>}
                    action={<Typography variant="h4">{qns[qnIndex].qnInWords}</Typography>}
                />

                {/*{qns[qnIndex].imageName !== null*/}
                {/*    ? <CardMedia*/}
                {/*        component="img"*/}
                {/*        image={BASE_URL + 'Images/' + qns[qnIndex].imageName}*/}
                {/*        sx={{ height:210, width: 'auto', m: '10px auto' }} />*/}
                {/*    : null}*/}

                <ImageList
                    sx={{ width: '100%', height: 310, alignSelf: 'center' }}
                    variant="quilted"
                    cols={3}
                    rowHeight={100}
                >
                    {itemData.map((item) => (
                        <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>
                            <img
                                {...srcset(item.img, 100, item.rows, item.cols)}
                                alt={item.title}
                                loading="lazy"
                            />
                        </ImageListItem>
                    ))}
                </ImageList>


                <CardContent sx={{ alignSelf: 'center', m: 1 }}>
                    {/*<Typography variant="h6">*/}
                    {/*    {qns[qnIndex].qnInWords}*/}
                    {/*</Typography>*/}
                    <List dense={true} disablePadding={true}>
                        {qns[qnIndex].options.map((introitem, introidx) =>
                            <ListItemButton key={introidx} sx={{ fontSize: '0.85rem', m: '1px' }}>
                                {introitem !== null ?
                                    <div sx={{ height: 'auto' }}>
                                        <b>{String.fromCharCode(65 + introidx) + " . "}</b>{introitem}
                                    </div>
                                    : null}
                            </ListItemButton>
                        )}
                    </List>
                </CardContent>
                <CardActions>
                    {qnIndex > 0 ? <Button size="small"
                        onClick={() => getPrevious()}>Previous</Button> : null}
                    {qnIndex < qns.length - 1 ? <Button size="small"
                        onClick={() => getNext()}>Next</Button> : null}
                    {/*<Button size="small" sx={{ m: '20px', fontSize: '0.75' }} onClick={() => submitQuiz()}>HIRING</Button>*/}
                    {/*<Button size="small" sx={{ m: '20px', fontSize: '0.75' }} onClick={() => getTrip()}>Ride</Button>*/}
                </CardActions>
            </Card>
            : <Box sx={{
                display: 'flex',
                visibility: showAlert ? 'visible' : 'hidden'
            }}>
                <CircularProgress />
            </Box>
    );

    //}
}





//import React, { Component } from 'react';

//export class Home extends Component {
//  static displayName = Home.name;

//  render() {
//    return (
//      <div>
//        <h1>Hello, world!</h1>
//        <p>Welcome to your new single-page application, built with:</p>
//        <ul>
//          <li><a href='https://get.asp.net/'>ASP.NET Core</a> and <a href='https://msdn.microsoft.com/en-us/library/67ef8sbd.aspx'>C#</a> for cross-platform server-side code</li>
//          <li><a href='https://facebook.github.io/react/'>React</a> for client-side code</li>
//          <li><a href='http://getbootstrap.com/'>Bootstrap</a> for layout and styling</li>
//        </ul>
//        <p>To help you get started, we have also set up:</p>
//        <ul>
//          <li><strong>Client-side navigation</strong>. For example, click <em>Counter</em> then <em>Back</em> to return here.</li>
//          <li><strong>Development server integration</strong>. In development mode, the development server from <code>create-react-app</code> runs in the background automatically, so your client-side resources are dynamically built on demand and the page refreshes when you modify any file.</li>
//          <li><strong>Efficient production builds</strong>. In production mode, development-time features are disabled, and your <code>dotnet publish</code> configuration produces minified, efficiently bundled JavaScript files.</li>
//        </ul>
//        <p>The <code>ClientApp</code> subdirectory is a standard React application based on the <code>create-react-app</code> template. If you open a command prompt in that directory, you can run <code>npm</code> commands such as <code>npm test</code> or <code>npm install</code>.</p>
//      </div>
//    );
//  }
//}
